import { API_URL } from "../../../config";

const hdrs = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

export const api = {
  get: (p: string) => fetch(`${API_URL}${p}`, { headers: hdrs() }).then((r) => r.json()),
  post: (p: string, b: any) =>
    fetch(`${API_URL}${p}`, { method: "POST", headers: hdrs(), body: JSON.stringify(b) }).then((r) => r.json()),
  del: (p: string) => fetch(`${API_URL}${p}`, { method: "DELETE", headers: hdrs() }).then((r) => r.json()),
};

export const PRICING_TYPES = [
  { value: "per_event", label: "Per Event" },
  { value: "per_person", label: "Per Person" },
  { value: "per_hour", label: "Per Hour" },
  { value: "per_plate", label: "Per Plate" },
  { value: "per_unit", label: "Per Unit" },
] as const;

export const PRICING_LABELS: Record<string, string> = {
  per_event: "Per Event",
  per_person: "Per Person",
  per_hour: "Per Hour",
  per_plate: "Per Plate",
  per_unit: "Per Unit",
};

export const fmtCAD = (n: number) =>
  n.toLocaleString("en-CA", { style: "currency", currency: "CAD" });

export const T = {
  navy: "#0d1b2a",
  gold: "#c9a96e",
  cream: "#faf8f4",
  white: "#fff",
  bg: "#f7f5f1",
  slate: "#5c6b7e",
  slateLt: "#9ca8b7",
  line: "#eeebe6",
  greenBg: "#edf7ee",
  greenTx: "#2d6a35",
  redTx: "#9b2c2c",
  redBg: "#fef2f2",
  peach: "#ffebd3",
  inputBg: "#f8f7f5",
};

export const inputSx = {
  "& .MuiInputBase-root": {
    fontSize: 13.5,
    borderRadius: "10px",
    bgcolor: T.inputBg,
    border: `1px solid ${T.line}`,
    "&.Mui-focused": { bgcolor: T.peach, borderColor: T.gold },
    transition: "all 0.15s",
    "& fieldset": { border: "none" },
  },
  "& .MuiInputLabel-root": { fontSize: 13 },
  "& input": { pt: "22px", pb: "6px" },
};

export const DEFAULT_COLORS = [
  "#8b5cf6", "#ec4899", "#f59e0b", "#3b82f6",
  "#10b981", "#ef4444", "#06b6d4", "#f97316",
];
